export const viewModeType = {
    New : "NEW",
    Edit : "EDIT"
};

// 사진대지에서 "설치 확인 신청 번호" 라벨을 쓰는 프로젝트 (그 외는 "설치 계획서 번호")
export const instlApplyNoPjtSeqList = ["114", "116"];

export const getInstlPlndocNoLabel = (pjtSeq) =>
    instlApplyNoPjtSeqList.includes(String(pjtSeq)) ? "설치 확인 신청 번호" : "설치 계획서 번호";